import React, { useState } from 'react';

import ThemeLogo from './ThemeLogo';
import { Button, CircularProgress, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import { send_request_without_auth } from '../../utils/Request';

const isValidEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

function ForgotUsername() {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleForgotUsername = () => {
    setError('');
    setButtonLoading(true);

    let lowerCaseEmail = email.toLowerCase();
    let isErrorEmail = !isValidEmail(lowerCaseEmail);

    if (!isErrorEmail) {
      send_request_without_auth(
        'authz-service/forgot_username',
        { email: lowerCaseEmail },
        null,
        'POST'
      )
        .then(() => {
          setHasSubmitted(true);
          setButtonLoading(false);
        })
        .catch(e => {
          console.log(e);
          setError('There was an error processing your request');
          setButtonLoading(false);
        });
    } else {
      setError('Please enter a valid email');
      setButtonLoading(false);
    }
  };

  if (hasSubmitted) {
    return (
      <div className="mainDiv">
        <div className="auth-stagger">
          <div className="auth-logo">
            <ThemeLogo />
          </div>
          <div>
            <h4>Check your email</h4>
            <p className="auth-subtitle">
              We've sent a message to <strong>{email}</strong> with any usernames connected to that email address.
            </p>
          </div>
          <div>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <Button
                variant="outlined"
                color="inherit"
                style={{ borderRadius: 8, marginTop: 8 }}
              >
                Back to sign in
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mainDiv">
      <div className="auth-stagger">
        <div className="auth-logo">
          <ThemeLogo />
        </div>
        <div>
          <h4>Recover your username</h4>
          <p className="auth-subtitle">
            Enter your email and we'll send you all usernames linked to it.
          </p>
        </div>
        <div className="inputArea">
          <p className="inputDescription">Email address</p>
          <TextField
            id="resetUserName"
            key="resetUserName"
            name="resetUserName"
            fullWidth
            placeholder="name@company.com"
            variant="outlined"
            type="text"
            size="small"
            value={email}
            onChange={e => {
              if (error !== '') setError('');
              setEmail(e.target.value);
            }}
            error={error !== ''}
            helperText={error}
          />
        </div>
        <div
          style={{
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
            marginTop: 20,
          }}
        >
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              color="inherit"
              style={{ borderRadius: 8 }}
            >
              Back
            </Button>
          </Link>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={handleForgotUsername}
            disabled={buttonLoading}
            style={{ borderRadius: 8, minWidth: 100, position: 'relative' }}
          >
            {buttonLoading ? '' : 'Submit'}
            {buttonLoading && <CircularProgress size={20} color="inherit" />}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ForgotUsername;
